import {CertificateI18n} from '@/locales/base.message.locales';

export const certificates: CertificateI18n = {
  download_pdf: 'Download PDF',
  collaboration: {
    text_team: 'We certify that <strong>{contestant_name}</strong>, as a member of the <strong>{team_name}</strong> team' +
      'participated in the <strong>{challenge_title}</strong> challenge launched and coordinated by ' +
      '<strong>{challenge_responsible_name}</strong> between {challenge_accepted_at} to {challenge_closed_at}.',
    text_user: 'We certify that <strong>{contestant_name}</strong>, participated in the <strong>{challenge_title}</strong>' +
      ' challenge launched and coordinated by <strong>{challenge_responsible_name}</strong> between {challenge_accepted_at} to {challenge_closed_at}.',
    certificate: 'Certificate',
    challenge: 'Challenge',
    team: 'Team',
    issued: 'Issued',
    valid: 'Valid',
    invalid: 'Invalid',
    no_certificate_found: 'No certificate found!',
    text_verify_alert: 'For your security, only the logged-in user can see this certificate.',
  }
};
